export default __webpack_public_path__ + "static/media/teach-4.ef30fe9d.png";